<template>
    <span v-if="isGray">
        <img
            v-if="isRead"
            src="@/assets/images/icons/bell-gray.svg"
            alt="notification"
        />
        <img
            v-else
            src="@/assets/images/icons/bell-gray-dot.svg"
            alt="notification"
        />
    </span>
    <span v-else>
        <img
            v-if="isRead"
            src="@/assets/images/icons/bell-gray.svg"
            alt="notification"
        />
        <img
            v-else
            src="@/assets/images/icons/bell-blue-dot.svg"
            alt="notification"
        />
    </span>
</template>

<script>
export default {
    name: 'NotificationBell',
    props: {
        isRead: {
            type: Boolean,
            require: true,
        },
        isGray: {
            type: Boolean,
            require: false,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import 'NotificationBell';
</style>
